// extracted by mini-css-extract-plugin
export default {"footer":"footer_footer__IS2Cb","sideBlock":"footer_sideBlock__BNrFU","leftBlock":"footer_leftBlock__D4yIQ","rightBlock":"footer_rightBlock__djdAi"};